import React from "react";
import "./List_Card_Clothing.scss";
import {useHistory} from "react-router";

function List_Card_Clothing({item,merchantId}) {

    const history = useHistory()

    return(
<div className="list-wrap">
    <div className="list-card-clothing-container">
        <div className="like">
            <img className="like-ico" src="/svg/heart.svg" alt=""/>
        </div>
        <div onClick={()=>{
            history.push(`/online-clothing-product/${merchantId}/${item.uid}`)
        }}>
            <div className="pro-img">
                <img className="product-img" src={item.image} alt=""/>
            </div>
            <div className="footer">
                <span className="name">{item.name.length>20?' ...'+item.name.substr(0,20):item.name}</span>
                <span className="amount">{item.price} ریال </span>
            </div>
            </div>
    </div>
</div>
    )
}
export {List_Card_Clothing}

